<template>
    <div class="relatorios-personalizados">
        <hal-gerador-relatorios formato-lista="Lista" produto-id="150"></hal-gerador-relatorios>
    </div>
</template>

<script>
export default {
    name: 'RelatoriosPersonalizados'
}
</script>

<style scoped lang="stylus">
.relatorios-personalizados
    width 100%
</style>
